import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ENTITLEMENTS_PLATFORM_TYPES } from '@adsk/alloy-provider';
import { Box, Flex } from '@adsk/alloy-react-box';
import { LogoAutodeskAccIcon, LogoAutodeskBim360Icon } from '@adsk/alloy-react-icon';
import { MenuItem } from '@adsk/alloy-react-menu';
import theme from '@adsk/alloy-react-theme';
import HighlightedItemText from './HighlightedItemText';
import { MFAIcon } from './MFAIcon';
import getAnchorRel from '../helpers/getAnchorRel';
import getAnchorTarget from '../helpers/getAnchorTarget';
import getProjectUrl from '../helpers/getProjectUrl';
import { projectShape } from '../helpers/propTypes';
const StyledImg = styled.img.withConfig({
  displayName: "ProjectListProjectItem__StyledImg",
  componentId: "sc-1f1wj6r-0"
})(["width:100%;height:100%;object-fit:contain;border-radius:5px;"]);
const ProjectListProjectItem = _ref => {
  let {
    item: project,
    search,
    currentProjectId,
    currentProductId,
    onClose,
    onProjectClick,
    handleAnalyticOnClick,
    containerRef
  } = _ref;
  const {
    id,
    platform
  } = project;
  const url = getProjectUrl(project, currentProductId);
  const highlighted = currentProjectId === id;
  const LogoComponent = platform === ENTITLEMENTS_PLATFORM_TYPES.ACC ? LogoAutodeskAccIcon : LogoAutodeskBim360Icon;
  return /*#__PURE__*/React.createElement(MenuItem, {
    "data-testid": "ProjectPicker__project-".concat(id),
    rel: getAnchorRel(url),
    highlighted: highlighted,
    showSelection: false,
    as: onProjectClick ? 'button' : 'a',
    href: url,
    target: getAnchorTarget(url),
    onClick: () => {
      onProjectClick === null || onProjectClick === void 0 ? void 0 : onProjectClick(project, url);
      handleAnalyticOnClick === null || handleAnalyticOnClick === void 0 ? void 0 : handleAnalyticOnClick(project);
      onClose === null || onClose === void 0 ? void 0 : onClose();
    },
    style: {
      height: 'auto',
      padding: '8px 16px',
      textAlign: 'initial'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 1,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "48px",
    height: "48px",
    marginRight: "16px"
  }, /*#__PURE__*/React.createElement(StyledImg, {
    src: project.imageUrl ? project.imageUrl : undefined,
    "data-testid": "item-image"
  })), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    maxWidth: "216px"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Box, {
    typography: "heading4",
    color: highlighted ? 'white' : 'charcoal900',
    ellipsis: "multi"
  }, /*#__PURE__*/React.createElement(HighlightedItemText, {
    search: search,
    text: project.name,
    highlighted: highlighted
  })), project.jobNumber && /*#__PURE__*/React.createElement(Box, {
    typography: "caption",
    color: highlighted ? 'white' : 'charcoal800',
    ellipsis: "single"
  }, /*#__PURE__*/React.createElement(HighlightedItemText, {
    search: search,
    text: project.jobNumber,
    highlighted: highlighted
  })), /*#__PURE__*/React.createElement(Box, {
    typography: "caption",
    color: highlighted ? 'white' : 'charcoal600',
    ellipsis: "single"
  }, project.accountName)), project.mfaBlocked && /*#__PURE__*/React.createElement(MFAIcon, {
    containerRef: containerRef
  }))), /*#__PURE__*/React.createElement(LogoComponent, {
    size: 16,
    style: {
      color: highlighted ? theme.colors.white : theme.colors.acsLogoBlue,
      marginLeft: theme.spacing.medium
    }
  })));
};
ProjectListProjectItem.displayName = 'ProjectListProjectItem';
ProjectListProjectItem.propTypes = {
  /** The project item to show */
  item: projectShape,
  /** current selected project id */
  currentProjectId: PropTypes.string,
  /** current product ID, to check if project has entitlements for or not */
  currentProductId: PropTypes.string,
  /** menu close handler */
  onClose: PropTypes.func,
  /** project click handler */
  onProjectClick: PropTypes.func
};
export default ProjectListProjectItem;
//# sourceMappingURL=ProjectListProjectItem.js.map